import { useMemo } from 'react';
import { z } from 'zod';
import { useEmirateField } from '../../../members/members-form/fields';
import { usePolicyEffectiveDateField } from '../fields';
import { IEidMembersForm } from '../types';

export const useEidCommonFieldsStructure = () => {
	const emirateField = useEmirateField<IEidMembersForm>();
	const policyEffectiveDateField = usePolicyEffectiveDateField<IEidMembersForm>();

	const emirateIdFieldsStructure = useMemo(
		() => [emirateField.getField({ field: 'emirateId' })],
		[emirateField.getField]
	);
	const policyEffectiveDateFieldsStructure = useMemo(
		() => [policyEffectiveDateField.getField({ field: 'policyEffectiveDate' })],
		[policyEffectiveDateField.getField]
	);

	const getValidations = () =>
		z.object({}).merge(emirateField.getValidation()).merge(policyEffectiveDateField.getValidation());

	return {
		policyEffectiveDateFieldsStructure,
		emirateIdFieldsStructure,
		getValidations,
	};
};
